import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';

import useProjectDefinition from 'src/app/projects/views/new-project-definition/hooks/useProjectDefinition';
import styles from 'src/app/projects/views/new-project-definition/NewProjectDefinition.module.scss';
import CompletionBadge from 'src/shared/components/completion-badge/CompletionBadge';
import ListOfErrors from 'src/shared/components/list-of-errors/ListOfErrors';
import BasicInformation from './components/basic-information/BasicInformation';
import CustomerContacts from './components/customer-contacts/CustomerContacts';
import { getSectionErrors } from '../../helpers/sectionValidation';
import { getSectionStatus } from '../../helpers/sectionCompletion';

export const ProjectDetails = () => {
    const { formState } = useProjectDefinition();
    const errors = getSectionErrors(formState, 'projectDetails');
    const status = getSectionStatus(formState, 'projectDetails');

    return (
        <div className={styles.formView}>
            <div className={styles.formViewTitle}>
                <span>Project details</span>
                <div className={styles.sectionStatus}>
                    {status.isComplete && <CheckCircle className={styles.completeIcon} />}
                    {status.hasErrors && <AlertCircle className={styles.errorIcon} />}
                    <CompletionBadge completedFields={status.completedFields} totalFields={status.totalFields} />
                </div>
            </div>
            <BasicInformation />

            <CustomerContacts />

            <ListOfErrors errors={errors} className={styles.formSection} />
        </div>
    );
};

export default ProjectDetails;
